// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
// import FastClick from 'fastclick'
import App from './App'
import router from './router'
import 'babel-polyfill'
import './assets/fonts/iconfont.css'
import i18n from './assets/lang/index'
import uploader from '@/components/upload'
Vue.use(uploader)

// import Vant from 'vant'
// import 'vant/lib/index.css'

// FastClick.attach(document.body)
Vue.config.productionTip = false

// Vue.use(Vant)

/* eslint-disable no-new */
// new Vue({
//   el: '#app',
//   router,
//   components: { App },
//   template: '<App/>'
// })

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js